import React, { useState, useEffect, useCallback } from "react";
import HistorialTable from "../components/HistorialTable";
import {
  obtenerHistorial,
  registrarOperacion,
  eliminarOperacion,
  getComprasByProducto,
  getComprasByProveedor,
  getVentasByProducto,
  descargarExcel,
  obtenerHistorialFiltrado
} from "../services/historial";
import '../styles/GestionOperaciones.css';
import { FaFileExcel } from "react-icons/fa";
import { HistorialOperacion } from "../types";

const GestionOperaciones: React.FC = () => {
  const [tipo, setTipo] = useState<'compra' | 'venta'>("compra");
  const [historial, setHistorial] = useState<HistorialOperacion[]>([]);
  const [fechaInicio, setFechaInicio] = useState<string>('');
  const [fechaFin, setFechaFin] = useState<string>('');


  const cargarHistorial = useCallback(async () => {
    if (fechaInicio || fechaFin) return;
    try {
      const data = await obtenerHistorial(tipo);
      setHistorial(data);
    } catch (error) {
      console.error("Error cargando historial:", error);
    }
  }, [tipo, fechaInicio, fechaFin]);

  const cargarHistorialFiltrado = useCallback(async () => {
    if (!fechaInicio || !fechaFin) return; // pide fechas válidas
    try {
      const data = await obtenerHistorialFiltrado({ tipo, fechaInicio, fechaFin });
      setHistorial(data);
    } catch (error) {
      console.error("Error cargando historial filtrado:", error);
    }
  }, [tipo, fechaInicio, fechaFin]);

  useEffect(() => {
    if (fechaInicio && fechaFin) {
      cargarHistorialFiltrado();
    } else {
      cargarHistorial();
    }
  }, [cargarHistorial, cargarHistorialFiltrado, fechaInicio, fechaFin]);

  const descargarExcelHandler = () => {
    descargarExcel({ fechaInicio, fechaFin, tipo })
  }
  const handleRegistrar = async (datos: any) => {
    try {
      await registrarOperacion(tipo, datos);
      cargarHistorial();
    } catch (error) {
      console.error("Error registrando operación:", error);
    }
  };

  const handleEliminar = async (id: number) => {
    try {
      await eliminarOperacion(tipo, id);
      cargarHistorial();
    } catch (error) {
      console.error("Error eliminando operación:", error);
    }
  };

  const handleFiltrarPorProducto = async (producto_id: number) => {
    const data =
      tipo === "compra"
        ? await getComprasByProducto(producto_id)
        : await getVentasByProducto(producto_id);
    setHistorial(data);
  };

  const handleFiltrarPorProveedor = async (proveedor_id: number) => {
    if (tipo === "compra") {
      const data = await getComprasByProveedor(proveedor_id);
      setHistorial(data);
    }
  };

  return (
    <div className="gestion-operaciones">
      <h2>Gestión de {tipo === "compra" ? "Compras" : "Ventas"}</h2>
      <div className="tabs">
        <button onClick={() => setTipo("compra")}>Compras</button>
        <button onClick={() => setTipo("venta")}>Ventas</button>
      </div>
      <div className="filtros-header">
        <div className="fechas-btns">
          <div>
            <p>Fecha de inicio</p>
            <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
          </div>
          <div>
            <p>Fecha final</p>
            <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} />
          </div>
        </div>

        <button className="btn-excel" onClick={descargarExcelHandler}>
          <FaFileExcel style={{ marginRight: '8px', fontSize: "1.2em" }} />
          Descargar Excel Reporte
        </button>
      </div>
      <HistorialTable
        historial={historial}
        onEliminar={handleEliminar}
        onFiltrarPorProducto={handleFiltrarPorProducto}
        onFiltrarPorProveedor={handleFiltrarPorProveedor}
        tipo={tipo}
      />
    </div>
  );
};

export default GestionOperaciones;
